"use strict";

import React from 'react';
import AppStore from '../stores/AppStore';
import MigrationExitButton from './MigrationExitButton.react';

/**
 * Web 9: the purchases have already been transferred to Rakuten TV.
 */
export default class MigrationComplete extends React.Component {
    render() {
        return (
            <div className="migration-outcome-overlay">
                <h1 className="migration-outcome-overlay__lead">
                    {AppStore.translate('view.migration_overlay.web9.body')}
                </h1>
                <div className="overlay-content migration-outcome-overlay__content">
                    <p>{AppStore.translate('view.migration_overlay.web9.detail')}</p>
                    <MigrationExitButton
                        label={AppStore.translate('view.migration_overlay.web9.exit_cta')}
                    />
                </div>
            </div>
        );
    }
}
